<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 27.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Laugh" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<style type="text/css">
	.stLaugh1{fill:#302C3B;}
	.stLaugh2{fill:#FDCA47;enable-background:new    ;}
	.stLaugh3{fill:#302C3B;enable-background:new    ;}
	.stLaugh4{fill:#F46C60;enable-background:new    ;}
</style>
<path class="stLaugh1" d="M116,125.1c0-8.9,9.6-14.7,17.5-10.4l89.9,47.9c10.7,5.7,10.7,21.1,0,26.8l-89.9,47.9
	c-7.9,4.3-17.5-1.5-17.5-10.4c0-2.8,0.1-5.5,2.8-7.7l36-43.2l-36-43.2C116.1,130.6,116,127.9,116,125.1L116,125.1z M393.2,132.8
	l-36,43.2l36,43.2c1.8,2.2,2.8,4.9,2.8,7.7c0,8.9-9.6,14.7-17.5,10.4l-89.9-47.9c-10.7-5.7-10.7-21.1,0-26.8l89.9-47.9
	c7.9-4.3,17.5,1.5,17.5,10.4C396,127.9,395,130.6,393.2,132.8L393.2,132.8z"/>
<path class="stLaugh2" d="M0,256C0,114.6,114.6,0,256,0s256,114.6,256,256S397.4,512,256,512S0,397.4,0,256z M256,432
	c76.1,0,140.2-50,159.2-117.9c3.9-13.7-7.4-26.1-21.6-26.1H118.4c-14.2,0-25.5,12.4-21.6,26.1C115.8,382,179.9,432,256,432L256,432z
	 M133.5,114.7c-7.9-4.3-17.5,1.5-17.5,10.4c0,2.8,0.1,5.5,2.8,7.7l36,43.2l-36,43.2c-2.7,2.2-2.8,4.9-2.8,7.7
	c0,8.9,9.6,14.7,17.5,10.4l89.9-47.9c10.7-5.7,10.7-21.1,0-26.8L133.5,114.7z M396,125.1c0-8.9-9.6-14.7-17.5-10.4l-89.9,47.9
	c-10.7,5.7-10.7,21.1,0,26.8l89.9,47.9c7.9,4.3,17.5-1.5,17.5-10.4c0-2.8-1-5.5-2.8-7.7l-36-43.2l36-43.2
	C395,130.6,396,127.9,396,125.1L396,125.1z"/>
<path class="stLaugh3" d="M256,432c76.1,0,140.2-50,159.2-117.9c3.9-13.7-7.4-26.1-21.6-26.1H118.4c-14.2,0-25.5,12.4-21.6,26.1
	C115.8,382,179.9,432,256,432L256,432z"/>
<path class="stLaugh4" d="M256,361.4c-35.3,0-65.3,21.9-76.4,52.5c22.8,11.6,48.8,18.2,76.4,18.2c27.6,0,53.5-6.6,76.4-18.1
	C321.3,383.3,291.3,361.4,256,361.4z"/>
</svg>
